export default __webpack_public_path__ + "static/media/oola_w.46e78c57.svg";